module.exports = __webpack_public_path__ + "static/media/menu_parametrizacao.fbbada48.png";